import React, { useEffect } from "react";
import Product from "../Product/Product";
import style from "./listProducts.module.css";
import CategoryNav from "../Navbar/CategoryNav";
import axios from "axios";

import { useSearchParams } from "react-router-dom";
import ProductNotFound from "../ProductNotFound/ProductNotFound";
import { useDispatch, useSelector } from "react-redux";
import { saveProductList } from "../../redux/userSlice";

function ListProducts() {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.products);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const getProducts = async () => {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API_PORT}/products`,
          method: "GET",
          params: {
            category: searchParams.get("category"),
          },
        });
        dispatch(saveProductList(response.data));
      } catch (error) {
        console.log(error);
      }
    };
    getProducts();
  }, [searchParams]);

  return (
    products && (
      <>
        {products.length ? (
          <>
            <CategoryNav />
            <div className={style.containerProducts + " container mb-5"}>
              <div className="row m-5 d-flex flex-column">
                <h2 className={style.h2Products + " col-12 text-center"}>
                  Productos
                </h2>
                <h5 className={style.h5Products + " text-center"}>
                  Date el gustito más rico ;)
                </h5>
              </div>
              <div className="row d-flex justify-content-center">
                {products.map((product) => (
                  <Product key={product.id} product={product} />
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <CategoryNav />
            <ProductNotFound />
          </>
        )}
      </>
    )
  );
}

export default ListProducts;
